import { CircleCheck, Clock, Mark, OverlaySpinner } from '@ankr.com/ui';

import { ECryptoDepositStepStatus } from 'modules/payments/types';

interface IActionStatusProps {
  status: ECryptoDepositStepStatus;
  size?: number;
}

export const ActionStatus = ({ size = 20, status }: IActionStatusProps) => {
  switch (status) {
    case ECryptoDepositStepStatus.Complete:
      return <CircleCheck color="success" size={size} />;

    case ECryptoDepositStepStatus.Error:
      return <Mark color="error" size={size} />;

    case ECryptoDepositStepStatus.Pending:
      return <OverlaySpinner size={size} />;

    case ECryptoDepositStepStatus.Confirming:
      return <CircleCheck color="success" size={size} />;

    case ECryptoDepositStepStatus.Initializing:
    default:
      return <Clock size={size} sx={{ color: 'text.secondary' }} />;
  }
};
